<style scoped>
</style>
<template>
    <div>
        <div style="font-size: 20px;padding: 20px;">
            <div>{{config.data?config.data.name:''}}</div>
            <div v-if="options.history" style="color: #aaa;font-size: 12px;">当前正在浏览历史版本，创建于 {{options.history.version}}</div>
            <div v-if="config.tips" style="color: #aaa;font-size: 12px;">* {{config.tips}}</div>
        </div>
        <Form ref="form" v-if="form" :model="form" hide-required-mark :rules="rules" label-position="top" style="border-top: 1px solid #f1f1f1;">
            <div style="display: flex;">
                <div :style="`padding:20px;width:${col.width?(col.width + 40):300}px;word-break:break-all;box-sizing: border-box;${colIndex==config.form.cols.length-1?'':'border-right: 1px solid #f1f1f1;'}`" v-for="(col,colIndex) in config.form.cols" :key="colIndex">
                    <slot v-if="col.slot" :name="col.slot"></slot>
                    <div v-else>
                        <div v-for="(item,index) in col.items" :key="index" v-if="item.vif?item.vif(form):!item.hide">
                            <div v-if="item.type=='title'" style="font-size: 18px;margin-bottom: 20px;">{{item.value}}</div>
                            <FormItem :prop="item.key" :label="item.name" v-if="item.type=='text'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <Input v-if="config.editable && !item.readonly && !(item.constant && config.current)" v-model="form[item.key]" :placeholder="item.placeholder||'请输入'" style="width: 100%;" :maxlength="item.maxlength||500" :show-word-limit="item['show-word-limit']||false" :disabled="item.disabledif?item.disabledif(form):false"></Input>
                                <div v-else-if="item.render" :style="`${item.style};`">{{item.render(item.key?form[item.key]:(item.readonly?config.current:form))}}</div>
                                <div v-else-if="form[item.key]" :style="`${item.style};`">{{form[item.key]}}</div>
                                <div v-else style="color: #aaa;">无</div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='number'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div style="display: flex;">
                                    <div v-if="item.slot && item.slot.prepend">{{item.slot.prepend(form)}}</div>
                                    <div v-if="config.editable && !item.readonly && !(item.constant && config.current)" style="position: relative; width: 100%;">
                                        <Input v-model.number="form[item.key]" :placeholder="item.placeholder||'请输入'" style="width: 100%;" :disabled="item.disabledif?item.disabledif(form):false" :min="item.min" :max="item.max">
                                        <Select v-if="item.unit && item.unit.type=='selector'" v-model="form[item.unit.key]" slot="append" style="width: 70px" :disabled="item.disabledif?item.disabledif(form):false">
                                            <Option v-for="(u, idx) in item.unit.selections" :key="u.value || u" :value="u.value || u">{{u.name || u}}</Option>
                                        </Select>
                                        </Input>
                                    </div>
                                    <div v-else>{{form[item.key]}}<span v-if="item.unit">{{(item.unit.selections.find(s=>s==form[item.unit.key]||s.value==form[item.unit.key]))?(item.unit.selections.find(s=>s==form[item.unit.key]||s.value==form[item.unit.key]).name||item.unit.selections.find(s=>s==form[item.unit.key]||s.value==form[item.unit.key])):''}}</span></div>
                                    <div v-if="item.slot && item.slot.append">{{item.slot.append(form)}}</div>
                                </div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='image'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <Uploader :current="form[item.key]" :editable="config.editable && !item.readonly && !(item.constant && config.current)" :multi="item.multi" :max="item.max" v-on:confirm="form[item.key]=$event"></Uploader>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='textarea'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <Input v-if="config.editable && !item.readonly && !(item.constant && config.current)" type="textarea" v-model="form[item.key]" :rows="item.rows||4" :placeholder="item.placeholder||'请输入'" :maxlength="item.maxlength||500" :show-word-limit="item['show-word-limit']||false" :disabled="item.disabledif?item.disabledif(form):false" />
                                <div v-else>{{form[item.key]}}</div>
                            </FormItem>
                            <div v-else-if="item.type=='label'" :style="`${item.style};`">
                                {{item.render?item.render(form):item.value}}
                                <div style="height: 20px;"></div>
                            </div>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='switch'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <i-switch :disabled="!(config.editable && !item.readonly && !(item.constant && config.current))" v-model="form[item.key]">
                                    <span slot="open">是</span>
                                    <span slot="close">否</span>
                                </i-switch>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='daterange'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <DatePicker v-if="config.editable && !item.readonly && !(item.constant && config.current)" :clearable="item.clearable||false" :value="form[item.key]" :format="item.format || 'yyyy-MM-dd'" @on-change="daterangeChanged(item,$event)" type="daterange" style="width:100%" placement="bottom-end" placeholder="请选择" :disabled="item.disabledif?item.disabledif(form):false">
                                </DatePicker>
                                <div v-else-if="form[item.key] && form[item.key][0]">{{form[item.key][0]}} - {{form[item.key][1]}}</div>
                                <div v-else style="color: #aaa;">无</div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='time'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <TimePicker v-if="config.editable && !item.readonly && !(item.constant && config.current)" format="HH:mm" :value="form[item.key]" @on-change="form[item.key]=$event" placeholder="请选择" style="width: 112px" :disabled="item.disabledif?item.disabledif(form):false"></TimePicker>
                                <div v-else-if="form[item.key]">{{form[item.key]}}</div>
                                <div v-else style="color: #aaa;">无</div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='date'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <DatePicker v-if="config.editable && !item.readonly && !(item.constant && config.current)" :format="item.format || 'yyyy-MM-dd'" :value="form[item.key]" @on-change="form[item.key]=$event" placeholder="请选择" style="width: 100%" :disabled="item.disabledif?item.disabledif(form):false"></DatePicker>
                                <div v-else-if="form[item.key]">{{form[item.key]}}</div>
                                <div v-else style="color: #aaa;">无</div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='datetime'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <DatePicker v-if="config.editable && !item.readonly && !(item.constant && config.current)" :format="item.format || 'yyyy-MM-dd HH:mm:ss'" type="datetime" :value="form[item.key]" @on-change="datePickerChanged(form,item,$event)" placeholder="请选择" style="width: 100%" :disabled="item.disabledif?item.disabledif(form):false"></DatePicker>
                                <div v-else-if="form[item.key]">{{form[item.key]}}</div>
                                <div v-else style="color: #aaa;">无</div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='custom'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <CustomData :current="form[item.key]" :editable="config.editable && !item.readonly && !(item.constant && config.current)" :multi="item.multi" :moveable="item.moveable" :max="item.max" :datatype="item.datatype" :unimode="item.unimode" :query="item.query" :fields="item.fields" :columns="item.columns" v-on:confirm="form[item.key]=$event" :useMendianSelector="item.useMendianSelector"></CustomData>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='biaodanziduan'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <FormItemEditor :current="form[item.key]" :editable="config.editable && !item.readonly && !(item.constant && config.current)" :max="item.max" v-on:confirm="form[item.key]=$event"></FormItemEditor>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='checkbox'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <!-- <CustomData :current="form[item.key]" :editable="config.editable && !item.readonly" :multi="item.multi" :max="item.max" :datatype="item.datatype" v-on:confirm="form[item.key]=$event"></CustomData> -->
                                <CheckboxGroup v-model="form[item.key]">
                                    <Checkbox v-for="selection in item.loader?item.loader(form):item.selections" :key="selection" :label="selection">{{selection}}</Checkbox>
                                </CheckboxGroup>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='list'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <TextList :options="item" :current="form[item.key]"></TextList>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='radio'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <RadioGroup v-model="form[item.key]" v-if="config.editable && !item.readonly && !(item.constant && config.current)" :disabled="item.disabledif?item.disabledif(form):false" @on-change="item.change?item.change({form}):null">
                                    <Radio :label="r.value" v-for="(r,i) in item.loader?item.loader(form):item.selections" :key="i" :disabled="r.disabled">
                                        <span>{{r.name}}</span>
                                    </Radio>
                                </RadioGroup>
                                <div v-else>
                                    <span>{{item.selections.find(o=>o.value==form[item.key])?item.selections.find(o=>o.value==form[item.key]).name:''}}</span>
                                </div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='selector'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <div v-if="item.multi">
                                    <div v-if="config.editable && !item.readonly && !(item.constant && config.current)">
                                        <Select :value="form[item.key].map(i=>{return item.render(i)})" :filterable="item.filterable||false" :clearable="item.clearable||false" multiple @on-change="selectorChanged(item,$event)" :placeholder="item.placeholder||'请选择'" :disabled="item.disabledif?item.disabledif(form):false">
                                            <Option v-for="(selection,selectionindex) in item.loader?item.loader(form):item.selections" :value="item.render(selection)" :key="selectionindex">{{ item.render(selection) }}</Option>
                                        </Select>
                                    </div>
                                    <div v-else>{{item.render(form[item.key])}}</div>
                                </div>
                                <div v-else>
                                    <div v-if="config.editable && !item.readonly && !(item.constant && config.current)">
                                        <Select :value="item.render(form[item.key])" :filterable="item.filterable||false" :clearable="item.clearable||false" @on-change="selectorChanged(item,$event)" :placeholder="item.placeholder||'请选择'" :disabled="item.disabledif?item.disabledif(form):false">
                                            <Option v-for="(selection,selectionindex) in item.loader?item.loader(form):item.selections" :value="item.render(selection)" :key="selectionindex" class="nowrap" :style="`${item.width?('width:'+item.width+'px'):''}`">{{ item.render(selection) }}</Option>
                                        </Select>
                                    </div>
                                    <div v-else>{{item.render(form[item.key])}}</div>
                                </div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='location'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <div v-if="form[item.key]" @click="locationSelector.show(item.key)" class="center hover" style="color: #20bf64;font-weight: bold;height: 80px;border-radius: 6px;text-align: center;background: url('http://cdn.igyl.com/vendor-statics/mapbg.png');">
                                    <div>{{form[item.key].name}}</div>
                                </div>
                                <div v-else @click="locationSelector.show(item.key)" class="center hover" style="color: #20bf64;font-weight: bold;height: 80px;border-radius: 6px;text-align: center;background: url('http://cdn.igyl.com/vendor-statics/mapbg.png');">
                                    <div>在地图中选择</div>
                                </div>
                            </FormItem>
                            <FormItem :prop="item.key" :label="item.name" v-else-if="item.type=='jigou'||item.type=='gonghuojigou'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="!form[item.key]" style="font-size: 12px;margin-left: 4px;">{{item.description}}</div>
                                <BaseSelect v-if="config.editable && !item.readonly && !(item.constant && config.current)" :value="form[item.key]" autoload :multiple="item.multi" :type="item.type" width="100%" :parameter="item.query" :placeholder="item.placeholder" @change="jigouChanged(item,$event)" :disabled="item.disabledif?item.disabledif(form):false" />
                                <BaseSelect v-else readonly :value="form[item.key]" :multiple="item.multi" :type="item.type" />
                            </FormItem>

                            <FormItem :prop="item.key" :label="item.name" v-if="item.type=='slot'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div v-if="item.slot">
                                    <slot v-if="item.slot" :name="item.slot"></slot>
                                </div>
                            </FormItem>

                            <FormItem :prop="item.key" :label="item.name" v-if="item.type=='a'">
                                <FormItemLabel slot="label" :item="item"></FormItemLabel>
                                <div>
                                    <a @click="item.onclick({form,item})">{{item.render?item.render(item.key?form[item.key]:form):form[item.key]}}</a>
                                </div>
                            </FormItem>

                            <div v-if="item.tip">
                                <div style="font-size: 12px;color: #aaa;margin-top: -20px;margin-bottom: 20px;">{{item.tip}}</div>
                            </div>

                            <div v-if="col.spacer">
                                <div :style="`height: ${col.spacer}px;`"></div>
                            </div>

                            <!-- <FormItem prop="fenlei" label="分类">
                        <Select v-model="form.fenlei" filterable>
                            <Option v-for="(item,index) in fenleis" :key="index" :value="item.name" :label="item.name" :disabled="item.disabled">
                                <span>{{item.name}}</span>
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="env" label="商品类型">
                        <RadioGroup v-model="form.env">
                            <Radio :label="item.value" v-for="(item,index) in envs" :key="index">
                                <span>{{item.name}}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                     -->
                        </div>
                    </div>
                </div>
            </div>
        </Form>
        <div style="padding: 20px;border-top: 1px solid #f1f1f1;">
            <Caozuojilu v-if="config.current && config.caozuojiluOn" :items="caozuojilus"></Caozuojilu>
            <div class="jcsb">
                <div v-if="config.mode!='page'">
                    <div v-if="config.current && config.editable && config.delete && deleteable" class="hover" style="color: red;" @click="toDelete">删除</div>
                </div>
                <div class="center">
                    <Button @click="cancel" style="margin-right: 10px;">取消</Button>
                    <Button v-if="config.editable" type="primary" @click="toSave({})" :loading="loading" style="width: 100px;">保存</Button>
                    <Button v-if="config.submitable" type="primary" @click="toSave({tijiao:true})" :loading="loading" style="width: 100px;margin-left: 10px;">保存并提交</Button>
                    <slot name="menus"></slot>
                </div>
            </div>
        </div>

        <Modal v-model="locationSelector.display" class="nopadding" footer-hide :width="500">
            <LocationSelector v-if="locationSelector.display" :current="locationSelector.current" v-on:cancel="locationSelector.display=false;" v-on:locationSelected="locationSelector.confirm"></LocationSelector>
        </Modal>
    </div>
</template>
<script>
    import FormItemLabel from './FormItemLabel'
    import LocationSelector from '@/components/common/LocationSelector.vue'
    export default {
        components: {
            FormItemLabel,
            LocationSelector
        },
        props: {
            options: Object,
        },
        data() {
            return {
                config: {},
                current: null,
                loading: true,
                form: null,
                rules: {
                    // name: [{ required: true, message: ' ', trigger: 'blur' }],
                },
                caozuojilus: [],
                uploadConfig: {
                    token: null,
                    field: 'image',
                },
                locationSelector: {
                    display: false,
                    field: null,
                    current: null,
                    show: (field) => {
                        this.locationSelector.display = true
                        this.locationSelector.current = this.form[field] ? this.form[field].value : null
                        this.locationSelector.field = field
                    },
                    confirm: async (value) => {
                        this.loading = true
                        let res = await this.$api.post('/web/main/location/parse', {
                            location: value
                        })
                        this.loading = false
                        this.form[this.locationSelector.field] = {
                            value,
                            name: res.data.locationStr,
                            city: res.data.city,
                            cityStr: res.data.cityStr,
                            detail: res.data.locationDetail
                        }
                        this.locationSelector.display = false
                    }
                }
            }
        },
        computed: {
            deleteable() {
                let value = false
                if (this.config.deleteable === undefined) {
                    value = true
                } else {
                    value = !!this.config.deleteable
                }
                if (this.config.deleteableif) {
                    value = this.config.deleteableif(this.current)
                }
                return value
            }
        },
        mounted() {
            this.config = this.copy(this.options)
            this.init()
        },
        methods: {
            async init() {
                // if (this.config.deleteable === undefined) { this.config.deleteable = true }
                // if (this.config.deleteableif) {
                //     this.config.deleteableif(this.form)
                // }
                let form = {}
                let rules = {}
                let items = []
                for (let col of this.config.form.cols) {
                    if (!col.slot) {
                        items = items.concat(col.items)
                    }
                }
                for (let item of items) {
                    if (!item.key) continue
                    form[item.key] = item.default
                    if (item.default === undefined) {
                        if (item.multi || item.type == 'list') {
                            form[item.key] = []
                        } else {
                            form[item.key] = null
                        }
                    }
                    if (item.type == 'selector' && !item.render) {
                        item.render = (data) => {
                            if (data && data.name) {
                                return data.name
                            } else {
                                return data
                            }
                        }
                    }
                    if (item.type == 'number' && item.unit) {
                        if (item.unit.default && form[item.unit.key] === undefined) {
                            form[item.unit.key] = item.unit.default
                        }
                    }

                    if (item.type == 'selector' && !item.selections) {
                        item.selections = []
                    }
                    if (item.required) {
                        if (item.type == 'text' || item.type == 'textarea') {
                            rules[item.key] = [{ required: true, message: ' ', trigger: 'blur' }]
                        } else if (item.type == 'number') {
                            let rule = { required: true, type: 'number', message: item.message || ' ', trigger: 'blur' }
                            let min = typeof item.min === 'number' ? item.min : undefined
                            let max = typeof item.max === 'number' ? item.max : undefined
                            if (min !== undefined) rule.min = min
                            if (max !== undefined) rule.max = max
                            rules[item.key] = [rule]
                        } else if (item.type == 'image' || item.type == 'custom') {
                            rules[item.key] = [{ required: true, type: 'object', message: ' ', trigger: 'blur' }]
                        } else if (item.multi || item.type == 'list' || item.type == 'daterange') {
                            rules[item.key] = [{ required: true, type: 'array', min: 1, message: '至少选择一项', trigger: 'blur' }]
                        } else if (item.type == 'jigou' || item.type == 'gonghuojigou') {
                            rules[item.key] = [{ required: true, type: 'object', message: ' ', trigger: 'blur' }]
                        } else {
                            if (item.required == 'object') {
                                rules[item.key] = [{ required: true, type: 'object', message: '请填写', trigger: 'blur' }]
                            } else if (item.required == 'list') {
                                rules[item.key] = [{ required: true, type: 'array', min: 1, message: '至少选择一项', trigger: 'blur' }]
                            } else {
                                rules[item.key] = [{ required: true, type: 'string', message: '请填写', trigger: 'blur' }]
                            }
                        }
                    } else if (item.type == 'number' && (typeof item.min === 'number' || typeof item.max === 'number')) {
                        // 非必填但有min/max
                        let rule = { type: 'number', trigger: 'blur', message: item.message || ' ' }
                        let min = typeof item.min === 'number' ? item.min : undefined
                        let max = typeof item.max === 'number' ? item.max : undefined
                        if (min !== undefined) rule.min = min
                        if (max !== undefined) rule.max = max
                        rules[item.key] = [rule]
                    }
                }
                this.items = items
                await this.loadData(form)
                this.form = form
                this.options._form = form
                this.rules = rules
                if (this.options.onload) this.options.onload(form, this.current)
            },
            async loadData(_form) {
                let form = _form
                if (!form) { form = this.form }
                if (this.options.load) {
                    this.loading = true
                    let res = await this.options.load({ dataId: this.config.current ? this.config.current._id : null })
                    this.loading = false
                    let data = res.data[this.config.data.key]
                    if (data) {
                        this.current = data
                        for (let key of Object.keys(form)) {
                            if (data[key] !== undefined) {
                                form[key] = data[key]
                            }
                        }
                    }
                    if (this.config.caozuojiluOn && res.data.caozuojilus) this.caozuojilus = res.data.caozuojilus
                }
                if (this.config.init) this.config.init({ current: this.current, form: form, options: this.config })
                for (let item of this.items) {
                    if (item.init) item.init({ item, form: form, current: this.current })
                    if (item.load) {
                        let res = await item.load({ item, form: form, current: this.current })
                        if (item.type == 'selector' && res.data && res.data.items) {
                            item.selections = res.data.items || []
                        }
                    }
                }
            },
            cancel() {
                this.$emit('cancel')
            },
            async toSave({ tijiao }) {
                this.$refs['form'].validate(async (valid) => {
                    if (!valid) { return this.$Message.error('请检查输入') }
                    if (this.config.beforeSave) {
                        let r = await this.config.beforeSave({ current: this.current, form: this.form })
                        if (r.error) {
                            { return this.$Message.error(r.error) }
                        }
                    }
                    this.loading = true
                    let res = await this.options.save({ dataId: this.config.current ? this.config.current._id : null, form: this.form, tijiao, timestamp: this.config.current ? this.config.current.lastUpdateTime : null })
                    this.loading = false
                    if (!res || !res.data) { return }
                    if (res.data.success) {
                        this.$Message.success({ content: '操作成功', duration: 4, closable: true })
                        this.$emit('dataChanged', { type: this.config.current ? 'edit' : 'add', data: res.data[this.config.data.key] })
                    } else if (res.data.errors && res.data.errors[0]) {
                        this.$Message.error('保存失败：' + res.data.errors[0].error)
                    }
                })
            },
            async toDelete() {
                this.$Modal.confirm({
                    title: '操作确认',
                    render: (h) => {
                        return h('div', '删除操作不可恢复，确定要删除' + (this.config.current.name || '') + '？')
                    },
                    okText: '删除',
                    onOk: async () => {
                        this.loading = true
                        let res = await this.options.delete({ dataId: this.config.current._id })
                        this.loading = false
                        if (res.data.success) {
                            this.$Message.success({ content: '操作成功', duration: 4, closable: true })
                            this.$emit('dataChanged', { type: 'remove' })
                        } else if (res.data.errors && res.data.errors[0]) {
                            this.$Message.error('删除失败：' + res.data.errors[0].error)
                        }
                    }
                })
            },
            datePickerChanged(form, item, value) {
                if (item.endOfDay && value.indexOf('00:00:00') != -1) {
                    value = value.replace('00:00:00', '23:59:59')
                }
                if (value) {
                    value = this.moment(value).format(item.format || 'YYYY-MM-DD HH:mm:ss')
                    form[item.key] = value
                } else {
                    form[item.key] = null
                }
            },
            daterangeChanged(item, value) {
                // value[0] = value[0].replace(/\//g, '-')
                // value[1] = value[1].replace(/\//g, '-')
                this.form[item.key] = value
            },
            selectorChanged(item, value) {
                let selections = item.loader ? item.loader(this.form) : item.selections
                if (item.multi) {
                    let result = []
                    for (let i of value) {
                        for (let selection of selections) {
                            if (item.render(selection) == i) {
                                result.push(this.simple(selection, item.fields))
                                break
                            }
                        }
                    }
                    this.form[item.key] = result
                } else {
                    if (value === undefined) {
                        this.form[item.key] = undefined
                    } else {
                        for (let selection of selections) {
                            if (item.render(selection) == value) {
                                this.form[item.key] = this.simple(selection, item.fields)
                                break
                            }
                        }
                    }
                }
                if (item.change) {
                    item.change({ value: this.form[item.key], form: this.form, item, current: this.current })
                }
            },
            jigouChanged(item, value) {
                this.form[item.key] = this.simple(value, item.fields)
                if (item.change) {
                    item.change({ value: this.form[item.key], form: this.form, item, current: this.current })
                }
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/DefaultForm.vue?69ff569c